// @flow
import { connect } from 'react-redux';
import ScribeTranscriptList from './ScribeTranscriptList';

const mapStateToProps = state => {
  const {
    scribeTranscriptUI: { fontSize, electronCaptionMode },
    scribeConversation: {
      lang,
      loaded,
      speakers,
      status,
      transcriptsCurrent,
      transcriptsFinal,
    },
    scribeSession: {
      captioner,
      currentPlatform,
      features,
      inConferenceCall
    },
  } = state;

  return {
    currentPlatform,
    features,
    fontSize,
    electronCaptionMode,
    lang,
    loaded,
    inConferenceCall,
    speakers,
    status,
    transcriptsCurrent,
    transcriptsFinal,
    user: captioner,
  };
};

export default connect(mapStateToProps)(ScribeTranscriptList);
